module.exports = __webpack_public_path__ + "static/front/img/banner-2.5664e763.jpg";